import { render, staticRenderFns } from "./PlayersScreen.vue?vue&type=template&id=55e68ba8&scoped=true"
import script from "./PlayersScreen.vue?vue&type=script&lang=js"
export * from "./PlayersScreen.vue?vue&type=script&lang=js"
import style0 from "./PlayersScreen.vue?vue&type=style&index=0&id=55e68ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e68ba8",
  null
  
)

export default component.exports